import React from 'react';

import PropTypes from 'prop-types';

import { useFormattedUser } from '@adsk/alloy-provider';
import Avatar from '@adsk/alloy-react-avatar';
import ProgressRing from '@adsk/alloy-react-progress-ring';

import {
  StyledPackagesAvatar,
  StyledPackagesAvatarContent,
  StyledPackagesAvatarUserName,
  StyledPackagesAvatarCompanyName,
} from './PackagesAvatar.styles';

const PackagesAvatar = ({ oxygenId }) => {
  const { loading, formatDisplayUser } = useFormattedUser();

  if (loading) {
    return <ProgressRing size={ProgressRing.SIZES.XSMALL} />;
  }

  const { displayName, userDetails } = formatDisplayUser(oxygenId);

  if (!userDetails) {
    return null;
  }

  return (
    <StyledPackagesAvatar>
      <Avatar
        style={{ marginRight: 8 }}
        size={Avatar.SIZES.MEDIUM_24}
        name={displayName}
        imageUrl={userDetails.imageUrl}
      />
      <StyledPackagesAvatarContent>
        <StyledPackagesAvatarUserName>
          {displayName}
        </StyledPackagesAvatarUserName>
        <StyledPackagesAvatarCompanyName>
          {userDetails.companyName}
        </StyledPackagesAvatarCompanyName>
      </StyledPackagesAvatarContent>
    </StyledPackagesAvatar>
  );
};

PackagesAvatar.propTypes = {
  oxygenId: PropTypes.string.isRequired,
};

export default PackagesAvatar;
